import { Api } from '../api';
import { messages } from '../endpoints';
import type { ApiResponse, FileResponse } from '../../models';
import type {
  AddAttachmentsRequest,
  AddAttachmentsResponse,
  AddMessageRequest,
  DownloadAttachmentRequest,
  ReadThreadsRequest,
  RemoveAttachmentsRequest,
  ThreadMessagesResponse,
  ThreadResponse,
} from './models';

export class MessagesApi extends Api {
  static getThreads = (signal?: AbortSignal) => this.get<ApiResponse<ThreadResponse[]>>({ url: messages.getThreads(), signal });

  static getThreadMessages = (groupId: string, signal?: AbortSignal) =>
    this.get<ApiResponse<ThreadMessagesResponse[]>>({ url: messages.getThreadsMessages(groupId), signal });

  static readThread = (request: ReadThreadsRequest, signal?: AbortSignal) =>
    this.put<ReadThreadsRequest, ApiResponse<undefined>>({ url: messages.readThread(), data: request, signal });

  static deleteThread = (groupId: string, signal?: AbortSignal) => this.delete<null, undefined>({ url: messages.deleteThread(groupId), signal });

  static addMessage = (request: AddMessageRequest, signal?: AbortSignal) =>
    this.post<AddMessageRequest, ApiResponse<ThreadMessagesResponse>>({ url: messages.addMessage(), data: request, signal });

  static addAttachments = ({ messageId, request }: AddAttachmentsRequest, signal?: AbortSignal) =>
    this.post<FormData, ApiResponse<AddAttachmentsResponse>>({ url: messages.addAttachments(messageId), data: request, signal });

  static removeAttachment = ({ fileId, messageId }: RemoveAttachmentsRequest, signal?: AbortSignal) =>
    this.delete({ url: messages.removeAttachment(fileId, messageId), signal });

  static downloadAttachment = ({ fileId, messageId }: DownloadAttachmentRequest, signal?: AbortSignal) =>
    this.get<FileResponse>({ url: messages.downloadAttachment(fileId, messageId), signal });
}
